import WarningBox from "components/warning-box/warning-box.component";
import { useState } from "react";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as LeftArrow } from "assets/left-arrow.svg";

import { AuthContext } from "../../contexts/auth.context";

import useTranslate from "../../hooks/use-translate";

import "../login/login.style.scss";

const ForgotPassword = () => {
	const navigate = useNavigate();
	const { resetPassword } = useContext(AuthContext);
	const t = useTranslate("ForgotPassword");

	const [isSent, setIsSent] = useState(false);

	const handleSubmit = async (event) => {
		event.preventDefault();
		setIsSent(true);
		// const email = event.target.email.value;
		// await resetPassword(email);
		navigate("/verification");
	};

	return (
		<div className="login-container">
			<div className="login-left-side">
				{"// PLACEHOLDER //"}
				<br />
				{"// ADVERTISEMENT //"}
				<br />
				{"// IMAGE //"}
				<br />
				{"// LOGO //"}
				<br />
				{"// INTRO //"}
			</div>
			<form className="login-right-side" onSubmit={handleSubmit}>
				<div className="login-form-container">
					<Link to={"/"} style={{ width: "min-content" }}>
						<LeftArrow style={{ fontSize: "2rem" }} />
					</Link>
					<span className="title margin-m--top">{t("reset your password").toUpperCase()}</span>
					<input className="text-box" type="text" placeholder={t("email")} name="email" />
					<div className="flex gap-xl">
						{isSent && (
							<WarningBox text={"Verification code sent to the given email address."} isCheckmark />
						)}

						<div className="flex--grow flex">
							<button
								className="btn btn--red size500 w500 padding-s--block padding-xxl--inline margin-auto--left"
								style={{ width: "max-content", height: "min-content" }}
								type="submit"
							>
								{t("send confirmation").toUpperCase()}
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};
// <select onChange={handleLanguageSelector}>
// 	<option value="english">English</option>
// 	<option value="french">French</option>
// </select>

export default ForgotPassword;
